import { useNavigate } from 'react-router-dom';
import { useContext } from "react";

import { DashboardContext } from '../../context/DashboardContext';
import { logout } from '../../utils/api';

import Button from "../SharedComponents/Button";

import welcomeIllustration from '../../assets/images/dashboard.png';

function WelcomeNoAccess() {
    const navigate = useNavigate();

    const context = useContext(DashboardContext);

    const handleSuccessfulLogout = () => {
        context.setLoggedIn(false);
        navigate("/login");
    }

    const handleLogout = async () => {
        try {
            await logout();
            handleSuccessfulLogout();
        } catch (alert) {
            console.log(alert);
        }
    }

    return (
        <div className={
            "mx-auto h-screen p-8 bg-gradient-to-l from-primary-100 to-secondary-100 grid grid-flow-row gap-2 items-center " +
            "md:justify-center md:grid-cols-2 md:grid-flow-col"
        }>
            <div className={"flex items-center justify-center"}>
                <img className={"w-4/5"} alt="" src={welcomeIllustration} />
            </div>
            <div>
                <h1 className={"font-serif text-xl text-blue-gray-600 mb-6"}>
                    Hi {context.userDetails.name}, welcome to <span className={
                        "text-transparent bg-clip-text bg-gradient-to-br from-primary-600 to-secondary-600 font-medium"
                    }>
                        Psych Press Portal!
                    </span>
                </h1>
                <div className={"text-lg text-blue-gray-500"}>
                    You currently have access to the portal but have not been given further permissions to access any
                    parts of the portal. Please contact your administrator if you think there has been a mistake.
                </div>
                <div className={"mt-4"}>
                    <Button
                        text="Logout of Psych Press Portal"
                        onClick={handleLogout}
                        extraStyling={
                            "text-blue-gray-700 focus:ring-inset focus:ring-1 bg-blue-gray-100 " +
                            "hover:bg-blue-gray-200 focus:outline-none focus:ring-blue-gray-500"
                        }
                    />
                </div>
            </div>
        </div>
    );
}

export default WelcomeNoAccess;
